import { render, staticRenderFns } from "./ABtestListTable.vue?vue&type=template&id=73208965&scoped=true"
import script from "./ABtestListTable.vue?vue&type=script&lang=js"
export * from "./ABtestListTable.vue?vue&type=script&lang=js"
import style0 from "./ABtestListTable.vue?vue&type=style&index=0&id=73208965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73208965",
  null
  
)

export default component.exports